import { SvgIconProps, SvgIconTypeMap } from "@mui/material";
import { CommonProps, OverridableComponent } from "@mui/material/OverridableComponent";
import { withStyles, WithStyles } from "@mui/styles";
import colorsStyle from "assets/jss/mui-extras/colorsStyle";
import classNames from "classnames";
import { MuiColors } from "components/MuiExtras/Typography/MuiColor";
import * as React from "react";

interface IProps {
    icon: OverridableComponent<SvgIconTypeMap> & { muiName: string; };
    color?: MuiColors;
}

export type MuiIconSvgProps = Omit<SvgIconProps, "color" | "classes" | "ref">;

type LocalProps = IProps & MuiIconSvgProps & CommonProps & WithStyles<typeof colorsStyle>;

class MuiIconSvg extends React.PureComponent<LocalProps>
{
    render() {

        const { className, classes, icon, color, ...rest } = this.props;

        const SvgIcon: OverridableComponent<SvgIconTypeMap> = icon;

        return (
            <SvgIcon
                {...rest}
                color="inherit"
                className={
                    classNames(
                        className,
                        {
                            [classes[color]]: color,
                            [className]: className !== undefined
                        }
                    )
                }
            />
        );
    }
}

export default withStyles(colorsStyle)(MuiIconSvg);
